<template>
    <ul class="flex flex-col gap-0.5">
        <slot />
    </ul>
</template>
